import clsx from 'clsx';

import styles from './Icons.module.css';
import { QuestionMarkIconProps } from './types';

const QuestionMarkIcon = ({ className, ...rest }: QuestionMarkIconProps) => {
  return <span className={clsx(styles.questionMark, className)} {...rest} />;
};

export default QuestionMarkIcon;
